import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_label_list_hdr_RowClass} from '../../../dbschema/bl_wf_issue_label_list_hdr.model';

export class WfIssueLabelListModel extends BaseContainerModel {
    bl_wf_issue_label_list_hdr: bl_wf_issue_label_list_hdr_RowClass = new bl_wf_issue_label_list_hdr_RowClass();
}
